// extracted by mini-css-extract-plugin
export default {"button":"PaginationButton_button__Z2B1g","--prev":"PaginationButton_--prev__Fev+F"};